import { cn, SidebarTrigger } from "@devhop/ui";
import { useSidebarTotalBadgeCount } from "./SidebarNavAlertsContext";

type SidebarTriggerWithBadgeProps = React.ComponentProps<typeof SidebarTrigger>;

export function SidebarTriggerWithBadge(props: SidebarTriggerWithBadgeProps) {
  const total = useSidebarTotalBadgeCount();

  return (
    <span className="relative inline-flex shrink-0">
      <SidebarTrigger {...props} />
      {total > 0 ? (
        <span
          className={cn(
            "pointer-events-none absolute -top-1.5 -right-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 font-semibold text-[10px] text-destructive-foreground",
          )}
          aria-hidden
        >
          {total > 99 ? "99+" : total}
        </span>
      ) : null}
    </span>
  );
}
